import { stateList } from '@njpos/core';

const STATES = stateList();

// Every state is listed; ones without a rules pack yet can't be picked, and packs nobody has checked yet say so.
export function StatePicker({ value, onChange }: { value: string; onChange: (code: string) => void }) {
  return (
    <label>State<select value={value} onChange={(e) => onChange(e.target.value)}>
      {STATES.map((s) => (
        <option key={s.code} value={s.code} disabled={!s.supported}>
          {s.name}{!s.supported ? ' (coming soon)' : s.needsLegalCheck ? ' (rules not checked by a lawyer yet)' : ''}
        </option>
      ))}
    </select></label>
  );
}
